import { useTranslation } from "react-i18next";

// Translation plus the current reading direction, so components don't each re-derive it.
const useLang = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  return { t, i18n, isRTL, dir: isRTL ? "rtl" : "ltr" };
};

export default useLang;
